<template>
  <b-row class="mb-3 align-items-center">
    <b-col md="3">
      <date-picker
        placeholder="Date Range"
        class="mr-2 w-100"
        range
        v-model="localParams.dateRange"
        @input="emitParams()"
      ></date-picker>
    </b-col>

    <b-col md="3">
      <v-multiselect
        v-model="localParams.fleet_category"
        placeholder="Search Fleet Type"
        label="label"
        :options="optionsVehicleType"
        :multiple="true"
        required
        track-by="value"
        class="mr-2"
        @input="emitParams()"
      >
        <span slot="noResult">Fleet type not found.</span>
      </v-multiselect>
    </b-col>

    <b-col md="3">
      <v-multiselect
        v-model="localParams.fleet_id"
        placeholder="Search Fleet Name"
        label="label"
        :options="optionsFleets"
        :multiple="true"
        required
        track-by="value"
        class="mr-2"
        @input="emitParams()"
      >
        <span slot="noResult">Fleet name not found.</span>
      </v-multiselect>
    </b-col>

    <b-col md="2">
      <v-multiselect
        v-model="localParams.status"
        :options="statusOptions"
        :multiple="true"
        label="label"
        track-by="value"
        @input="emitParams()"
      ></v-multiselect>
    </b-col>

    <b-col md="1">
      <b-button variant="outline-primary" @click="$emit('onFilter')">
        <i class="fa fa-filter"></i>
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
export default {
  model: {
    prop: 'params',
    event: 'input',
  },
  props: {
    params: {
      type: Object,
      required: true,
    },
    optionsVehicleType: {
      type: Array,
      default: () => [],
    },
    optionsFleets: {
      type: Array,
      default: () => [],
    },
    statusOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      localParams: { ...this.params },
      showModalFilter: false,
    }
  },
  watch: {
    params: {
      handler(newVal) {
        this.localParams = { ...newVal }
      },
      deep: true,
    },
  },
  methods: {
    emitParams() {
      this.$emit('input', this.localParams)
    },
  },
}
</script>

<style scoped>
::v-deep(.mx-input) {
  height: 44px;
  line-height: 44px;
  padding: 0 12px;
  box-sizing: border-box;
}
</style>
